// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentReview_otr .appointment_info {
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin: 24px 0;
}

.AppointmentReview_otr .icon_text_otr {
	display: flex;
	align-items: center;
	gap: 14px;
}

.AppointmentReview_otr .icon_text_otr svg {
	width: 20px;
	height: 20px;
	padding-top: 2px;
}

.AppointmentReview_otr .icon_text_otr svg path {
	fill: var(--primary-color);
}

.AppointmentReview_otr .icon_text {
	font-size: 14px;
	font-family: "Poppins", sans-serif;
	font-weight: 400;
	line-height: 22px;
	letter-spacing: 0.01071em;
}

.confirm_text {
	font-size: 16px;
	line-height: 24px;
	color: var(--desc-color2);
	font-family: "Poppins", sans-serif;
	font-style: italic;
}

.steps_content_inside {
	height: calc(100% - 24%);
	padding: 16px 24px;
	background: #f2f0fa;
}

/* For mobile screens */
@media (max-width: 768px) {
	.steps_content_inside {
	  height: calc(100% - 15%); /* Adjust for mobile */
	  padding: 12px 16px; /* Reduced padding for smaller screens */
	}
  }
  
  /* For iPads and medium-sized screens */
  @media (min-width: 768px) and (max-width: 1024px) {
	.steps_content_inside {
	  height: calc(100% - 12%); /* Adjust for iPads */
	  padding: 14px 20px; /* Moderate padding for tablets */
	}
  }

.steps_content_inside::-webkit-scrollbar {
	width: 6px;
}

.steps_content_inside::-webkit-scrollbar-thumb {
	background: #a3a3a3;
}

.AppointmentCreated .header_heading {
	font-size: 1.25rem;
	line-height: 1.75rem;
	text-align: center;
	padding-top: 0.5rem;
	font-weight: bolder !important;
	color: #1f2327;
	letter-spacing: 0.00938em;
}

.AppointmentCreated hr {
	width: 24px;
	border: none !important;
	margin: 0.375rem auto 0;
	background: var(--primary-color);
	margin-top: 4px;
	margin-bottom: 0px;
}

.end_btn {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
}

.end_btn .end_button {
	display: flex;
	align-items: center;

	color: var(--dark-text-color);
	border: 1px solid var(--white-color);
	background-color: var(--white-color);
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
	margin-top: 1rem;
	padding: 1rem 1.5rem !important;
	height: auto !important;
	border-radius: 50px;
	-webkit-border-radius: 50px;
	-moz-border-radius: 50px;
	-ms-border-radius: 50px;
	-o-border-radius: 50px;
}

.end_btn .end_button:hover {
	color: var(--primary-color) !important;
	border: 1px solid var(--primary-color) !important;
	border-color: 1px solid var(--primary-color) !important;
}
.end_btn .end_button .button_icon {
	width: 13px;
	height: 13px;
	color: var(--primary-color);
	background: var(--primary-color);
	fill: var(--primary-color) !important;
}

.end_btn .end_button .button_text {
	font-size: 18px;
	line-height: 16px;
	font-weight: 600;
	text-align: center;
	padding-left: 10px;
	font-family: "Poppins", sans-serif;
	color: var(--dark-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/Components/AppointmentReview/AppointmentReview.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,kCAAkC;CAClC,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA,uBAAuB;AACvB;CACC;GACE,wBAAwB,EAAE,sBAAsB;GAChD,kBAAkB,EAAE,wCAAwC;CAC9D;EACC;;EAEA,uCAAuC;EACvC;CACD;GACE,wBAAwB,EAAE,qBAAqB;GAC/C,kBAAkB,EAAE,iCAAiC;CACvD;EACC;;AAEF;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;CACnB,8BAA8B;CAC9B,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,uBAAuB;CACvB,uBAAuB;CACvB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;;CAEnB,6BAA6B;CAC7B,oCAAoC;CACpC,oCAAoC;CACpC,2CAA2C;CAC3C,gBAAgB;CAChB,+BAA+B;CAC/B,uBAAuB;CACvB,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;CACC,sCAAsC;CACtC,iDAAiD;CACjD,uDAAuD;AACxD;AACA;CACC,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,gCAAgC;CAChC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,kCAAkC;CAClC,6BAA6B;AAC9B","sourcesContent":[".AppointmentReview_otr .appointment_info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tmargin: 24px 0;\n}\n\n.AppointmentReview_otr .icon_text_otr {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n}\n\n.AppointmentReview_otr .icon_text_otr svg {\n\twidth: 20px;\n\theight: 20px;\n\tpadding-top: 2px;\n}\n\n.AppointmentReview_otr .icon_text_otr svg path {\n\tfill: var(--primary-color);\n}\n\n.AppointmentReview_otr .icon_text {\n\tfont-size: 14px;\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-weight: 400;\n\tline-height: 22px;\n\tletter-spacing: 0.01071em;\n}\n\n.confirm_text {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: var(--desc-color2);\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-style: italic;\n}\n\n.steps_content_inside {\n\theight: calc(100% - 24%);\n\tpadding: 16px 24px;\n\tbackground: #f2f0fa;\n}\n\n/* For mobile screens */\n@media (max-width: 768px) {\n\t.steps_content_inside {\n\t  height: calc(100% - 15%); /* Adjust for mobile */\n\t  padding: 12px 16px; /* Reduced padding for smaller screens */\n\t}\n  }\n  \n  /* For iPads and medium-sized screens */\n  @media (min-width: 768px) and (max-width: 1024px) {\n\t.steps_content_inside {\n\t  height: calc(100% - 12%); /* Adjust for iPads */\n\t  padding: 14px 20px; /* Moderate padding for tablets */\n\t}\n  }\n\n.steps_content_inside::-webkit-scrollbar {\n\twidth: 6px;\n}\n\n.steps_content_inside::-webkit-scrollbar-thumb {\n\tbackground: #a3a3a3;\n}\n\n.AppointmentCreated .header_heading {\n\tfont-size: 1.25rem;\n\tline-height: 1.75rem;\n\ttext-align: center;\n\tpadding-top: 0.5rem;\n\tfont-weight: bolder !important;\n\tcolor: #1f2327;\n\tletter-spacing: 0.00938em;\n}\n\n.AppointmentCreated hr {\n\twidth: 24px;\n\tborder: none !important;\n\tmargin: 0.375rem auto 0;\n\tbackground: var(--primary-color);\n\tmargin-top: 4px;\n\tmargin-bottom: 0px;\n}\n\n.end_btn {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 8px;\n}\n\n.end_btn .end_button {\n\tdisplay: flex;\n\talign-items: center;\n\n\tcolor: var(--dark-text-color);\n\tborder: 1px solid var(--white-color);\n\tbackground-color: var(--white-color);\n\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);\n\tmargin-top: 1rem;\n\tpadding: 1rem 1.5rem !important;\n\theight: auto !important;\n\tborder-radius: 50px;\n\t-webkit-border-radius: 50px;\n\t-moz-border-radius: 50px;\n\t-ms-border-radius: 50px;\n\t-o-border-radius: 50px;\n}\n\n.end_btn .end_button:hover {\n\tcolor: var(--primary-color) !important;\n\tborder: 1px solid var(--primary-color) !important;\n\tborder-color: 1px solid var(--primary-color) !important;\n}\n.end_btn .end_button .button_icon {\n\twidth: 13px;\n\theight: 13px;\n\tcolor: var(--primary-color);\n\tbackground: var(--primary-color);\n\tfill: var(--primary-color) !important;\n}\n\n.end_btn .end_button .button_text {\n\tfont-size: 18px;\n\tline-height: 16px;\n\tfont-weight: 600;\n\ttext-align: center;\n\tpadding-left: 10px;\n\tfont-family: \"Poppins\", sans-serif;\n\tcolor: var(--dark-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
